import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.boundFocus = () => {
      if (this.element.value == "") {
        this.element.value = this.element.placeholder;
      }
    };
    this.boundBlur = () => {
      if (this.element.value == this.element.placeholder) {
        this.element.value = "";
      }
    };
    this.element.addEventListener("focus", this.boundFocus);
    this.element.addEventListener("blur", this.boundBlur);
  }

  disconnect() {
    this.element.removeEventListener("focus", this.boundFocus);
    this.element.removeEventListener("blur", this.boundBlur);
  }
}
